import { DOCUMENT } from '@angular/common';
import { ChangeDetectionStrategy, Component, DestroyRef, inject, Injector, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Router } from '@angular/router';
import { AlertService } from '@modules/alert/services/alert.service';
import { Subject } from 'rxjs';
import { JoinInvitationModalComponent } from './join-invitation-modal.component';
import { enforceJoinRoutePrivacy } from './join-route-privacy';

@Component({
  selector: 'app-join-invitation-host',
  standalone: true,
  template: '',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class JoinInvitationHostComponent implements OnInit {
  private readonly alerts = inject(AlertService);
  private readonly injector = inject(Injector);
  private readonly router = inject(Router);
  private readonly destroyRef = inject(DestroyRef);
  private readonly document = inject(DOCUMENT);
  private readonly close = new Subject<void>();

  public ngOnInit(): void {
    const restoreReferrerPolicy = enforceJoinRoutePrivacy(this.document);
    this.destroyRef.onDestroy(restoreReferrerPolicy);
    this.destroyRef.onDestroy(() => {
      this.close.next();
      this.close.complete();
    });
    this.alerts.show({
      appearance: 'sapphire-modal-custom',
      component: JoinInvitationModalComponent,
      injector: this.injector,
      width: 950,
      showUntil: this.close.pipe(takeUntilDestroyed(this.destroyRef)),
      onClose: () =>
        window.setTimeout(() => {
          if (this.router.url.startsWith('/join/')) void this.router.navigateByUrl('/mail');
        }),
    });
  }
}
